function StopPropogation(event: React.MouseEvent<HTMLElement>) {
	event.stopPropagation();
}

export default StopPropogation;
